// --- Types ---
export interface Role {
  id: string;
  name: string;
  description: string;
  role_type: string;
  is_system_role: boolean;
  company: string;
  company_name: string;
}

export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser: boolean;
  roles: Role[];
}

export interface NavigationItem {
  title: string;
  path: string;
  icon: React.ReactNode;
  icon_size: number;
  children?: NavigationItem[];
}

// --- Menu Config --- (Only superadmin)
export const ROLE_MENU_CONFIG: Record<'superadmin', string[]> = {
  superadmin: [
    'Dashboard',
    'Organization',
    'Organizations',
    'Create Organization',
    'Organization Admin Users',
    'Global Configuration',
    'Profile',
  ],
};

// --- Menu util functions ---
export function getAllowedMenuTitles(user?: User): string[] {
  if (!user) return [];
  
  // Only allow superadmin access
  if (user.is_superuser) {
    return ROLE_MENU_CONFIG.superadmin;
  }
  
  return []; // No access for non-superadmins
}

export function getMenuItemsForRole(
  menuItems: NavigationItem[],
  user?: User
): NavigationItem[] {
  const allowedMenus = getAllowedMenuTitles(user);
  return menuItems
    .filter((item) => allowedMenus.includes(item.title))
    .map((item) => {
      if (item.children?.length) {
        const filteredChildren = item.children.filter((child) =>
          allowedMenus.includes(child.title)
        );
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
      }
      return { ...item };
    });
}